<template>
   <div class="front-box" :class="{'mobile': type === 'mobile'}">
       <div class="img_txt_box_left">
           <div class="img_txt_box_left_txt">
               <h3>引言</h3>
               <!-- 之后用富文本 -->
               <div class="img_txt_box_left_container" v-if="type !== 'mobile'">
                    <vue-scroll>
                      <div v-html="util.fixIntro(appInfo.description)"></div>
                    </vue-scroll>
               </div>
             <div class="img_txt_box_left_container mobile" v-if="type === 'mobile'">
               <div v-html="util.fixIntro(appInfo.description)"></div>
             </div>
           </div>
       </div>
     <i class="front-close-btn" @click.stop="closePage('singleImgTextShow')"></i>
    </div>
</template>

<script>
export default {
  name: 'imgText',
  props: {
    type: String,
    appInfo: Object
  },
  data () {
    return {
    }
  },
  watch: {

  },
  mounted () {
  },
  methods: {
    closePage (txt) {
      this.$emit('closePage', { page: txt })
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }
  @function remMobile($px) {
    @return $px * (1/25) * 1rem;
  }

    .front-box {
      box-sizing: border-box;
        width: rem(1000);
        /*height: rem(400);*/
        margin: rem(170) auto 0;
        background: rgba(25, 35, 70, 0.8);
        box-shadow: 0px rem(12) rem(12) 0px rgba(30, 46, 79, 0.5);
        border-radius: rem(12);
        display: flex;
        border: 1px solid #FFE1BE;
      padding: 0 rem(100) rem(50);
      position: relative;
      &.mobile{
        width: remMobile(335);
        height: auto;
        margin: 0;
        /*margin: remMobile(50) auto 0;*/
        padding: 0 rem(20);
        position: fixed;
        left: remMobile(20);
        top: remMobile(50);
        right: remMobile(20);
        bottom: remMobile(50);
        .img_txt_box_left {
          height: 100%;

          .img_txt_box_left_txt {
            font-size: remMobile(12);
            font-weight: 300;
            color: #FFE1BE;
            line-height: remMobile(20);
            margin: auto;

            .img_txt_box_left_container {
              height: rem(240);
              &.mobile{
                height: auto;
                position: absolute;
                left: remMobile(20);
                right: remMobile(10);
                top: remMobile(100);
                bottom: remMobile(50);
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
              }
            }

            p {
              font-size: remMobile(12);
              font-weight: 300;
              color: #FFE1BE;
              line-height: remMobile(20);
              margin-bottom: remMobile(16);
              margin-right: rem(10);
            }

            h3 {
              font-size: remMobile(24);
              color: #FFE1BE;
              line-height: remMobile(20);
              margin-bottom: remMobile(20);
              font-weight: 300;
              margin-top: remMobile(60);
            }
          }
        }
        .front-close-btn{
          width: remMobile(25);
          height: remMobile(25);
          background: url("../assets/img/pc/icon-close.png") no-repeat 0 0;
          background-size: remMobile(25) remMobile(25);
          position: absolute;
          right: 0;
          top: remMobile(-30);
          cursor: pointer;
          z-index: 11;
        }
      }

        .img_txt_box_left {
            height: 100%;

            .img_txt_box_left_txt {
                font-size: rem(12);
                font-weight: 300;
                color: #FFE1BE;
                line-height: rem(20);
                margin: auto;

                .img_txt_box_left_container {
                }

                p {
                    font-size: rem(12);
                    font-weight: 300;
                    color: #FFE1BE;
                    line-height: rem(24);
                  /*margin-bottom: rem(16);*/
                }

                h3 {
                    font-size: rem(24);
                    color: #FFE1BE;
                    line-height: rem(20);
                    margin-bottom: rem(20);
                    font-weight: 300;
                    margin-top: rem(60);
                }
            }
        }

        .img_txt_box_right {
            width: rem(580);
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .img_txt_box_right_container {
                width: rem(500);
                height: rem(285);

                img {
                    width: rem(500);
                    height: rem(285);
                }

            }
        }

      .front-close-btn{
        width: rem(25);
        height: rem(25);
        background: url("../assets/img/pc/icon-close.png") no-repeat 0 0;
        background-size: rem(25) rem(25);
        position: absolute;
        right: rem(-30);
        top: rem(-30);
        cursor: pointer;
        z-index: 11;
      }

    }







</style>
